"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("../PanelItems");

var _classnames = _interopRequireDefault(require("classnames"));

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      bucketPath = _ref.bucketPath,
      accessKey = _ref.accessKey,
      securityToken = _ref.securityToken,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onChangeBucketAccessPathCallback = _ref.onChangeBucketAccessPathCallback,
      onClickBucketAccessPathCallback = _ref.onClickBucketAccessPathCallback,
      onChangeAccessKeyCallback = _ref.onChangeAccessKeyCallback,
      onClickAccessKeyCallback = _ref.onClickAccessKeyCallback,
      onChangeSecurityTokenCallback = _ref.onChangeSecurityTokenCallback,
      onClickSecurityTokenCallback = _ref.onClickSecurityTokenCallback,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      isSavingCredentials = _ref.isSavingCredentials,
      errorFields = _ref.errorFields;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install Gainsight, you'll need"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, (0, _preact.h)("span", {
    className: "text--bold panel-body-description-label"
  }, "A Gainsight user with Administrator or Super Administrator permissions:"), (0, _preact.h)("span", {
    className: "panel-body-description-label-meta"
  }, ' ', "this is required to retrieve your Gainsight-managed S3 bucket details."))), (0, _preact.h)("div", {
    className: "installation-description-details"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('text--bold', 'panel-body-title', 'panel-body-description-label')
  }, "Gainsight-managed S3 bucket details"), (0, _preact.h)("div", {
    className: "panel-body-description-label-meta"
  }, "To retrieve the following details, log in to Gainsight and navigate to Administration > Integrations > Connectors, and then press 'View S3 Config'.")))), (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-form-input qa-form-bucket-access-path"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Bucket access path",
    key: "bucketAccessPath",
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-bucket-access-path",
    value: bucketPath,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onChangeBucketAccessPathCallback(e.target.value);
    },
    onClick: function onClick() {
      return onClickBucketAccessPathCallback();
    },
    error: (0, _PanelItems.getErrorMessage)('bucketAccessPath', errorFields)
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-access-key"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Access key",
    key: "accessKey",
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-bucket-access-key",
    value: accessKey,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onChangeAccessKeyCallback(e.target.value);
    },
    onClick: function onClick() {
      return onClickAccessKeyCallback();
    },
    error: (0, _PanelItems.getErrorMessage)('accessKey', errorFields)
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-security-token"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Security token",
    key: "securityToken",
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-bucket-security-token",
    value: securityToken,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onChangeSecurityTokenCallback(e.target.value);
    },
    onClick: function onClick() {
      return onClickSecurityTokenCallback();
    },
    error: (0, _PanelItems.getErrorMessage)('securityToken', errorFields)
  }))), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: function onClickManage() {
      return _onClickManage();
    },
    onClickUninstall: function onClickUninstall() {
      return _onClickUninstall();
    }
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isSavingCredentials
  }));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      bucketPath = props.bucketPath,
      accessKey = props.accessKey,
      securityToken = props.securityToken,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      _onClickManage2 = props.onClickManage,
      _onClickUninstall2 = props.onClickUninstall,
      hasUnsavedChanges = props.hasUnsavedChanges,
      _onChangeBucketAccessPathCallback = props.onChangeBucketAccessPathCallback,
      _onClickBucketAccessPathCallback = props.onClickBucketAccessPathCallback,
      _onChangeAccessKeyCallback = props.onChangeAccessKeyCallback,
      _onClickAccessKeyCallback = props.onClickAccessKeyCallback,
      _onChangeSecurityTokenCallback = props.onChangeSecurityTokenCallback,
      _onClickSecurityTokenCallback = props.onClickSecurityTokenCallback,
      isSavingCredentials = props.isSavingCredentials,
      errorFields = props.errorFields;
  return {
    body: (0, _preact.h)(InstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      onChangeBucketAccessPathCallback: function onChangeBucketAccessPathCallback(value) {
        return _onChangeBucketAccessPathCallback(value);
      },
      onClickBucketAccessPathCallback: function onClickBucketAccessPathCallback() {
        return _onClickBucketAccessPathCallback();
      },
      onChangeAccessKeyCallback: function onChangeAccessKeyCallback(value) {
        return _onChangeAccessKeyCallback(value);
      },
      onClickAccessKeyCallback: function onClickAccessKeyCallback() {
        return _onClickAccessKeyCallback();
      },
      onChangeSecurityTokenCallback: function onChangeSecurityTokenCallback(value) {
        return _onChangeSecurityTokenCallback(value);
      },
      onClickSecurityTokenCallback: function onClickSecurityTokenCallback() {
        return _onClickSecurityTokenCallback();
      },
      onClickManage: function onClickManage() {
        return _onClickManage2();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall2();
      },
      bucketPath: bucketPath,
      accessKey: accessKey,
      securityToken: securityToken,
      errorFields: errorFields,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}